import "./css/title.css"

function Title() {
    const title = "Blina Construction Inc."

    return (
        <div className="title-div">
            <h1 className="title">{title}</h1>
        </div>
    )
}

export default Title;